/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Manager_Failed_Load_GroupsInputs */



/**
* | output |
* | --- |
* | "Failed to load groups: {error}" |
*
* @param {Knp_Manager_Failed_Load_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_failed_load_groups = /** @type {((inputs: Knp_Manager_Failed_Load_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Failed_Load_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec du chargement des groupes : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Gruppen konnten nicht geladen werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile caricare i gruppi: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить группы: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al cargar los grupos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`加载组失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`グループの読み込みに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`समूह लोड करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao carregar os grupos: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to load groups: ${i?.error}`)
});